import React, { useState, useEffect } from 'react'
import BlogPreview from '../components/BlogPreview';
import {BsArrowRight} from 'react-icons/bs';
import useWindowDimensions from '../hooks/WindowDimensionsHook';
import TitleUnderlined from '../components/TitleUnderlined';
import "../styles/latest-blogs.css"
import { getLatestBlogs } from '../services/API/BlogpostAPI';
import { useNavigate } from 'react-router-dom';

const LatestBlogsPage = () => {
  const navigate = useNavigate();
  const [latestBlogs, setLatestBlogs] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getLatestBlogs();
      setLatestBlogs(data);
    }
    fetchData();
  }, [])

  return (
    <div className='latestblogs__page'>
      <div className='latestblogs__title-container'>
        <TitleUnderlined 
            title="Laatste blogs"
            bold={true}
            color="black"
            fontSize="2.5rem"
        />
      </div>
      <div className='latestblogs__blogs-container'>
        {latestBlogs && latestBlogs.map(blog => (
          <BlogPreview
            title={blog.country}
            relativePathImg={blog.mainImagePath}
            undertext={blog.title} 
            onClick={() => navigate(`/blogs/${blog.id}`)}
            width="25vw"
            height="25vw"
          />
        ))}
      </div>
      <div className='latestblogs__more-blogs-container'>
        <div className='latestblogs__more-blogs-button'>
          <a onClick={() => navigate(`/blogs/all-blogs`)} className='latestblogs__more-blogs-button__text'>Meer blogs</a>
          <BsArrowRight
            color="black"
            size={30}
            className='latestblogs__more-blogs-button__arrow'
          />
        </div> 
      </div>
    </div>
  )
}

export default LatestBlogsPage
